import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Subject, catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CommonApiResponse } from 'src/app/models/common-api-response.model';


@Injectable({
    providedIn: 'root'
})
export class ControlService {
    private host = environment.base_url;
    container_close$ = new Subject();



    constructor(private http_client: HttpClient) { }

    private handleError(err: HttpErrorResponse) {
        return throwError(() => ({error: err.error, status: err.status}));
    }

    api_create_control(control: any) {
        return this.http_client.post<any>(this.host + '/control_board', control).pipe(
            catchError(this.handleError)
        )
    }



    api_update_control(control: any,id:string) {
        return this.http_client.put<CommonApiResponse>(this.host + '/control_board/'+id, control).pipe(
            catchError(this.handleError)
        )
    }

    api_delete_control(id:string) {
        return this.http_client.delete<CommonApiResponse>(this.host + '/control_board/'+id).pipe(
            catchError(this.handleError)
        )
    }

    api_get_control_by_id(id:string) {
        return this.http_client.get<any>(this.host + '/control_board/'+id).pipe(
            catchError(this.handleError)
        )
    }


    api_get_units_dropdown() {
        return this.http_client.get<CommonApiResponse>(this.host + '/units/dropdown').pipe(
            catchError(this.handleError)
        )
    }

    api_get_all_controls(unit_id:string){
        return this.http_client.get<CommonApiResponse>(this.host+'/control_board/control_data/'+unit_id).pipe(
            catchError(this.handleError)
        )
    }

    api_set_control_status(unit_id:string,data:any){
        return this.http_client.post<CommonApiResponse>(this.host + '/control_board/status/'+unit_id,data).pipe(
            catchError(this.handleError)
        )
    }



    api_get_controls_req() {
        return this.http_client.get<CommonApiResponse>(this.host + '/control_board').pipe(
            catchError(this.handleError)
        )
    }

    api_get_non_smart_devices_(){
        return this.http_client.get<CommonApiResponse>(this.host+'/device/non_smart_devices');
    }
}
